import { render } from "./PhoneCall.vue?vue&type=template&id=17241803"
import script from "./PhoneCall.vue?vue&type=script&lang=js"
export * from "./PhoneCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__